import { render } from "./Shif.vue?vue&type=template&id=188e89d4"
import script from "./Shif.vue?vue&type=script&lang=js"
export * from "./Shif.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__